var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconWater = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M34.2104 13.3852C30.807 7.76762 27.0215 2.90571 25.0678 0.507491C24.8064 0.186318 24.4141 -0.000125151 24 6.30289e-08C23.5858 6.30289e-08 23.1936 0.186443 22.9321 0.507616C20.9785 2.90658 17.193 7.77013 13.7896 13.3882C9.40361 20.6284 7.17969 26.6145 7.17969 31.1798C7.17969 40.4545 14.7252 48 23.9999 48C33.2746 48 40.8201 40.4545 40.8201 31.1798C40.8202 26.6115 38.5965 20.6246 34.2104 13.3852ZM26.3081 41.8048C25.3259 42.056 24.3064 42.1832 23.2773 42.1832C16.9933 42.1832 11.881 37.434 11.881 31.5964C11.881 30.1871 12.2528 28.5406 12.986 26.7027C13.1098 26.3921 13.4627 26.215 13.8105 26.2901C14.1581 26.365 14.3915 26.668 14.3557 26.9975C14.3129 27.3917 14.2911 27.7768 14.2911 28.1415C14.2911 34.4942 19.4099 39.814 26.198 40.5152C26.5358 40.5502 26.7994 40.8028 26.8263 41.1178C26.8534 41.4327 26.6357 41.7209 26.3081 41.8048Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 47.9999,
  height: 48,
  fill: "white"
})))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconWater, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_water.6eb211ee.svg";
export { ForwardRef as ReactComponent };